module.exports = __webpack_public_path__ + "img/18289fc4-f08d-426a-8069-6213a5e24465.83474a3b.png";